"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertDecoder = void 0;
var i18next_1 = __importDefault(require("i18next"));
var messages_js_1 = __importDefault(require("./i18n/messages.js"));
var AlertDecoder = /** @class */ (function () {
    function AlertDecoder(locale) {
        i18next_1.default
            .init({
            fallbackLng: 'en',
            debug: false,
            lng: locale,
            resources: messages_js_1.default
        });
    }
    AlertDecoder.prototype.decode = function (code) {
        switch (code) {
            case "PL-1-0":
                return i18next_1.default.t('planner:invalidOrigin');
            case "PL-1-1":
                return i18next_1.default.t('planner:invalidDestination');
            case "PL-1-2":
                return i18next_1.default.t('planner:destinationNotReachable');
            case "PL-1-3":
                return i18next_1.default.t('planner:notEnoughAccommodations');
            case "PL-2-0":
                return i18next_1.default.t('planner:alternativeOrigin');
            case "PL-2-1":
                return i18next_1.default.t('planner:alternativeDestination');
            default:
                return i18next_1.default.t('planner:defaultError');
        }
    };
    return AlertDecoder;
}());
exports.AlertDecoder = AlertDecoder;
